var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9008 21.2504H6.20078L6.20078 8.30039L13.1008 1.15039L14.0258 1.87539C14.2258 2.02539 14.3591 2.18789 14.4258 2.36289C14.4924 2.53789 14.5258 2.74206 14.5258 2.97539V3.17539L13.4258 8.30039H21.4008C21.8508 8.30039 22.2508 8.47539 22.6008 8.82539C22.9508 9.17539 23.1258 9.56706 23.1258 10.0004V11.7754C23.1258 11.9587 23.1008 12.1754 23.0508 12.4254C23.0008 12.6754 22.9341 12.8921 22.8508 13.0754L19.9258 19.8754C19.7591 20.2587 19.4883 20.5837 19.1133 20.8504C18.7383 21.1171 18.3341 21.2504 17.9008 21.2504ZM4.70078 8.30039L4.70078 21.2504H1.80078L1.80078 8.30039H4.70078Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.3e1880a4bd5a5ad0d2226ffd1576f532.svg";
export { ForwardRef as ReactComponent };